<script setup lang="ts">
import AddPlusIcon from '@/assets/icons/add-plus.svg?component'
import DeleteIcon from '@/assets/icons/delete.svg?component'
import { BoxComponent, ButtonComponent, FlexComponent, InputComponent, TitleComponent } from '@/ui-library'

type TodoItem = { key: number | string; value: string }

const todoItems = defineModel<TodoItem[]>('todoItems', { default: [] })

const addItem = () => {
  todoItems.value.push({ key: todoItems.value.length, value: '' })
}

const removeItem = (item: TodoItem) => {
  const index = todoItems.value.indexOf(item)
  if (index !== -1) {
    todoItems.value.splice(index, 1)
  }
}
</script>

<template>
  <BoxComponent v-for="(item, index) in todoItems" :key="item.key" :mb="24">
    <FlexComponent align="center" :gap="4">
      <FlexComponent flex="1" is-child>
        <el-form-item prop="todoList">
          <InputComponent v-model="item.value">
            <template #header>
              <TitleComponent :title="`To-do ${index + 1}`" />
            </template>
          </InputComponent>
        </el-form-item>
      </FlexComponent>
      <BoxComponent :mt="30">
        <ButtonComponent variant="transparent" is-icon @click="() => removeItem(item)">
          <el-icon :size="24" color="var(--secondary-64)">
            <DeleteIcon />
          </el-icon>
        </ButtonComponent>
      </BoxComponent>
    </FlexComponent>
  </BoxComponent>
  <ButtonComponent variant="outlined" @click="addItem">
    <template #iconLeft>
      <el-icon :size="24">
        <AddPlusIcon />
      </el-icon>
    </template>
    Add to-do
  </ButtonComponent>
</template>

<style scoped lang="scss"></style>
